import React, { FC } from 'react';
import Chip from '@mui/material/Chip';
import MuiTooltip from '@mui/material/Tooltip';
import moment from 'moment';
import translate from '@translate';
import { getDateTimeFormat } from 'src/utils/timeConstants';

export interface EgonBadgePropsType {
    orderId?: number | null;
    statusName?: string | null;
    statusAt?: string | null;
    'data-testid'?: string;
}

/** "Via EGON" chip with tooltip. Callers must gate it by employee + EGON.VIEW (never shown to customers). */
const EgonBadge: FC<EgonBadgePropsType> = (props) => {
    const lines: string[] = [];
    if (props.orderId) {
        lines.push(translate('orderDetail.egonBadgeOrderId', { id: props.orderId }));
    }
    if (props.statusName) {
        lines.push(translate('orderDetail.egonBadgeStatus', { status: props.statusName }));
    }
    if (props.statusAt) {
        lines.push(
            translate('orderDetail.egonBadgeStatusAt', { date: moment(props.statusAt).format(getDateTimeFormat()) })
        );
    }

    const chip = (
        <Chip
            label={translate('orderDetail.egonBadge')}
            color="info"
            size="small"
            data-testid={props['data-testid'] || 'order-egon-badge'}
        />
    );

    if (!lines.length) {
        return chip;
    }

    return (
        <MuiTooltip
            title={
                <>
                    {lines.map((line) => (
                        <div key={line}>{line}</div>
                    ))}
                </>
            }
        >
            {chip}
        </MuiTooltip>
    );
};

export default EgonBadge;
